/* @ngInject */
function UserActionCardController ($rootScope, $scope, $translate, $q, ModalService, UdsModalService) {
  const getAuditDetailDialogController = () => $q.when(import('../../../audit/dialogs/audit-detail/audit-detail-dialog.controller'))
  const getCampaignActionMaterialsDialogController = () => $q.when(import('../../../arts/dialogs/campaign-action-materials/campaign-action-materials-dialog.controller'))

  const api = {
    getAuditDetailDialogController,
    getCampaignActionMaterialsDialogController,
    _defineStatus,
    _openPostModal,
    _openAuditModal,
    _openMaterialsModal
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._defineStatus()
  }

  const deregisterUserActionsRealization = $rootScope.$on('campaign.actions.complete-action', () => {
    api._defineStatus()
  })

  $scope.$on('$destroy', () => {
    deregisterUserActionsRealization()
  })

  function _defineStatus () {
    const now = moment()
    let publicationDate = $scope.action.publicationDate || $scope.action.campaignStartDate
    let expirationDate = $scope.action.expirationDate || $scope.action.campaignDeliveryDate

    publicationDate = new Date(publicationDate).setHours(0, 0, 0, 0)
    expirationDate = new Date(expirationDate).setHours(0, 0, 0, 0)

    if ($scope.action.isActionCompleted) {
      $scope.action.status = 'DONE'
    } else if (moment(publicationDate).isAfter(now)) {
      $scope.action.status = 'SOON'
    } else if (moment(expirationDate).isSame(now, 'day')) {
      $scope.action.status = 'TODAY'
    } else if (moment(expirationDate).isBefore(now) || $scope.action.wasUnpublished) {
      $scope.action.status = 'NOT_DONE'
    } else {
      $scope.action.status = 'AVAILABLE'
    }
  }

  $scope.getStatusColor = () => {
    const colors = {
      AVAILABLE: 'feedbackColorBlueDark',
      TODAY: 'feedbackColorYellowDark',
      DONE: 'feedbackColorGreenDark',
      NOT_DONE: 'feedbackColorRedDark',
      SOON: 'neutralColorLowMediumLightest'
    }

    return colors[$scope.action.status]
  }

  $scope.getStatusIcon = () => {
    const icons = {
      AVAILABLE: 'clock',
      TODAY: 'clock',
      DONE: 'success',
      NOT_DONE: 'clear',
      SOON: 'clock'
    }

    return icons[$scope.action.status]
  }

  $scope.getStatusLabel = () => {
    const labels = {
      AVAILABLE: $translate.instant('availableUntil'),
      TODAY: $translate.instant('today') + ',',
      DONE: $translate.instant('campaignActionStatus.done'),
      NOT_DONE: $translate.instant('campaignActionStatus.notDone'),
      SOON: $translate.instant('campaignActionStatus.soon')
    }

    let label = labels[$scope.action.status]

    if (!$scope.action.status.includes('DONE')) {
      const publicationDate = $scope.action.publicationDate || $scope.action.campaignStartDate
      const expirationDate = $scope.action.expirationDate || $scope.action.campaignDeliveryDate
      const date = $scope.action.status === 'SOON' ? moment(publicationDate) : moment(expirationDate)
      const formattedDate = date.format('DD MMM')
      label += ' ' + formattedDate
    }

    return label
  }

  $scope.openAction = () => {
    const notAllowedStatuses = ['SOON', 'NOT_DONE', 'DONE']
    if (notAllowedStatuses.includes($scope.action.status)) return

    if ($scope.action.type === 'POST') {
      api._openPostModal()
    } else if ($scope.action.type === 'AUDIT') {
      api._openAuditModal()
    } else if ($scope.action.type === 'ART') {
      api._openMaterialsModal()
    }
  }

  function _openPostModal () {
    ModalService.showModal({
      templateId: 'newPost.html',
      templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
      destroyable: true,
      observeChanges: true,
      allowMultiple: true,
      data: {
        _postId: $scope.action.postId,
        _editMode: false
      }
    })
  }

  function _openAuditModal () {
    api.getAuditDetailDialogController().then(({ AuditDetailDialogController }) => {
      ModalService.showModal({
        controller: AuditDetailDialogController,
        templateId: 'auditDetail.html',
        templateUrl: '/audit/dialogs/audit-detail/audit-detail-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        data: {
          id: $scope.action.auditId,
          redirect: 'arts'
        }
      })
    })
  }

  function _openMaterialsModal () {
    api.getCampaignActionMaterialsDialogController().then(({ CampaignActionMaterialsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CampaignActionMaterialsDialogController,
        modalName: 'campaignActionMaterialsDialog',
        data: {
          action: $scope.action
        }
      })
      modal.open()
    })
  }
}

export { UserActionCardController }
